import { render, staticRenderFns } from "./NavSideBar.vue?vue&type=template&id=3444704a&"
import script from "./NavSideBar.vue?vue&type=script&lang=js&"
export * from "./NavSideBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports